module.exports = __webpack_public_path__ + "img/background_320.499e062a.png";